import { render } from "./imageAndTextTemplate.vue?vue&type=template&id=1d5dde3d&scoped=true"
import script from "./imageAndTextTemplate.vue?vue&type=script&lang=js"
export * from "./imageAndTextTemplate.vue?vue&type=script&lang=js"

import "./imageAndTextTemplate.vue?vue&type=style&index=0&id=1d5dde3d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\storyworld-everhouse-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d5dde3d"]])

export default __exports__